import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {AppComponent} from "../../../app.component";
import {SharedDataService} from "../../../services/shared-data.service";
import { v4 as uuid } from 'uuid';
import {NewValidationResult} from "../../../objects/newValidationResult";
import {AbstractControl, FormControl, FormGroup, ValidatorFn} from "@angular/forms";
import {parseYoutubeVideoID} from "../../../utils/parseUtils";
import {FS3Notification} from "../../../objects/notification";

@Component({
  selector: 'app-course-editor',
  templateUrl: './course-editor.component.html',
  styleUrls: ['./course-editor.component.scss']
})
export class CourseEditorComponent implements OnInit {

  @Input() application: AppComponent;
  @Input() payload: object;
  @Output() close = new EventEmitter<void>();
  @Output() success = new EventEmitter<void>();

  private formValidationMessages = {
    required: 'Value is required.',
    titleRequired: 'Title is required.',
    textRequired: 'Text is required.',
  };
  public validationResult: NewValidationResult;
  public componentForm: FormGroup = new FormGroup({});
  public titleValue: FormControl = new FormControl('', [this.titleValidator()]);
  public picture_src_ava: string;
  public picture_src_icon: string;
  public picture_src_preview: string;
  public aspect_ratio: number;

  state: string = 'editing';
  errMsg: string = '';
  public folderData: object;

  constructor(
    private sharedDataService: SharedDataService,
  ) { }

  ngOnInit(): void {
    this.folderData = this.payload['folderData']
    this.titleValue.setValue(this.payload['folderData']['name']);
    this.picture_src_ava = this.payload['folderData']['picture_src_ava'];
    this.picture_src_icon = this.payload['folderData']['picture_src_icon'];
    this.picture_src_preview = this.payload['folderData']['picture_src_preview'];
  }

  public handleSubmit(event: Event | void = null): boolean {
    if (event) {
      event.stopPropagation();
    }

    this.validationResult = new NewValidationResult();

    this.titleValue.updateValueAndValidity();

    if (!this.titleValue.valid) {
      const errorKey = Object.keys(this.titleValue.errors)[0]; // get error key from input errors
      this.validationResult.isValid = false;
      this.validationResult.messagesPerControls['titleValue'] = this.titleValue.errors[errorKey];
      return false;
    } else {
      this.validationResult = null; //hide validationResult leftovers
    }

    this.state = 'loading';

    this.payload['folderData']['name'] = this.titleValue.value;
    this.payload['folderData']['picture_src_ava'] = this.picture_src_ava;
    this.payload['folderData']['picture_src_icon'] = this.picture_src_icon;
    this.payload['folderData']['picture_src_preview'] = this.picture_src_preview;
    this.payload['folderData']['aspect_ratio'] = this.aspect_ratio;

    if(this.payload['doFolderInsert']) {
      this.doFolderInsert();
    } else {
      this.doFolderUpdate();
    }
    return false
  }

  private titleValidator(): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
      const value = control.value.toString().trim();
      if (!value) {
        return {required: this.formValidationMessages.titleRequired}
      }
      return null;
    };
  }

  private doFolderInsert() {
    this.application.apiService
      .insertFolderItem(this.application.user.magic_key,this.payload['folderData'])
      .subscribe(
        data => {
          let notification = new FS3Notification();
          notification.type = 'success';
          notification.text = 'Course has been created!';
          this.sharedDataService.pushNotification(notification);
          this.success.emit()
        },
        error => {
          const { exception } = error;
          if (exception && exception.error && exception.error.message) {
            let notification = new FS3Notification();
            notification.type = 'error';
            notification.text = exception.error.message;
            this.sharedDataService.pushNotification(notification);
            this.state = 'error';
          } else {
            //maybe close dialog
          }
        }
      )
  }

  private doFolderUpdate() {
    this.application.apiService
      .updateFolderItem(this.application.user.magic_key,this.payload['folderData'])
      .subscribe(
        data => {
          let notification = new FS3Notification();
          notification.type = 'success';
          notification.text = 'Course has been updated!';
          this.sharedDataService.pushNotification(notification);
          this.success.emit()
        },
        error => {
          const { exception } = error;
          if (exception && exception.error && exception.error.message) {
            let notification = new FS3Notification();
            notification.type = 'error';
            notification.text = exception.error.message;
            this.sharedDataService.pushNotification(notification);
            this.state = 'error';
          } else {
            //maybe close dialog
          }
        }
      )
  }

  public onNoClick(): void {
    //this.dialogRef.close({ isConfirmed: false });
    this.close.emit()
  }

}
